exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SrMoreText[data-v-50f95b2a]{display:flex;position:relative}.SrMoreText .txt[data-v-50f95b2a]{flex:1}.SrMoreText .btn[data-v-50f95b2a]{position:absolute;bottom:0;right:0;padding:0}.SrMoreText .hid[data-v-50f95b2a]{height:60px;overflow:hidden}.SrMoreText .show[data-v-50f95b2a]{height:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50f95b2a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./packages/SrMoreText/SrMoreText.vue
// module id = 225
// module chunks = 0